import { SecretsManagerClient, GetSecretValueCommand } from "@aws-sdk/client-secrets-manager";
const secretsClient = new SecretsManagerClient({ region: "us-west-2" });
// SecretId: either the Amazon Resource Name (ARN) or the friendly name of the secret
export async function getSecret(SecretId) {
    const { SecretString } = await secretsClient.send(new GetSecretValueCommand({
        SecretId,
    }));
    return JSON.parse(SecretString ?? "{}");
}
;
//# sourceMappingURL=get-secret.js.map